module.exports = __webpack_public_path__ + "img/yan_hua.f151016e.png";